import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { SpreadsheetComponent, SpreadsheetMainMenuItem } from '@progress/kendo-angular-spreadsheet';
import { Sheet } from '@progress/kendo-spreadsheet-common';
import * as fileSaver from 'file-saver';
import { set } from 'lodash';

@Component({
  selector: 'app-import-spreadsheet',
  templateUrl: './import-spreadsheet.component.html',
  styleUrls: ['./import-spreadsheet.component.scss']
})
export class ImportSpreadsheetComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() importFile: Blob;
  @Input() importId: string;
  @ViewChild('spreadsheet', { static: false }) spreadsheet: SpreadsheetComponent;
  public items: SpreadsheetMainMenuItem[] = [];
  pendingFileLoad: boolean;
  isLoading = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['importFile'] && changes['importFile'].currentValue) {
      this.loadFileToSpreadsheet();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loadFileToSpreadsheet();
    }, 1000);
  }

  private loadFileToSpreadsheet(): void {
    if (this.importFile) {
      this.isLoading = true;
      this.spreadsheet?.spreadsheetWidget.fromFile(this.importFile).then(() => {
        // Do something after the file is loaded
        // For example, disable the spreadsheet:
        this.isLoading = false;
      });
      this.pendingFileLoad = false;
      // Remove the setTimeout as we'll use the dataBound event instead
    } else {
      this.pendingFileLoad = true;
    }
  }

  disableSpreadsheet(): void {
    let sheet = this.spreadsheet.spreadsheetWidget.activeSheet() as Sheet;
    sheet.range('A1:AX5000').enable(false);
  }

  downloadImportFile() {
    fileSaver.saveAs(this.importFile);
  }

}
